import React, { useEffect } from 'react';
import { Router, useParams } from '@gatsbyjs/reach-router';
import { FlowRouteProps } from './flow';


function FlowManager({ location, flow }: FlowRouteProps) {

	const params = useParams();

	useEffect(() => {
		if (location?.pathname === flow.uri) {
			flow.next(location!, params);
		}
	}, []);

	return (
		<Router basepath={flow.uri}>
			{flow.steps.map(step => (
				<step.component
					key={step.path} 
					path={step.path + '/*'}
					flow={step.flow}
			    />
			))}
	    </Router>
	);
};

export default FlowManager;
